/**
 * TanStack Query hooks for `liftoff-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	liftoffIntegrationQueryKeys,
	type CreateLiftoffIntegrationBody,
	type ListLiftoffIntegrationResponse,
	type LiftoffIntegrationRow,
} from "./api";

export function useLiftoffIntegrationList(): UseQueryResult<ListLiftoffIntegrationResponse, Error> {
	return useQuery({
		queryKey: liftoffIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useLiftoffIntegrationCreate(): UseMutationResult<LiftoffIntegrationRow, Error, CreateLiftoffIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: liftoffIntegrationQueryKeys.all });
		},
	});
}

export function useLiftoffIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: liftoffIntegrationQueryKeys.all });
		},
	});
}
